import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { ChartContainer, ChartTooltip, ChartTooltipContent } from '@/components/ui/chart';
import { CHART_COLORS } from '@/utils/statisticsFormatters';

interface PlansAdoptionChartProps {
  data: Array<{ date: string; [key: string]: number | string }>;
}

export const PlansAdoptionChart = ({ data }: PlansAdoptionChartProps) => {
  const chartConfig = {
    free: {
      label: 'Free',
      color: CHART_COLORS.plans.free,
    },
    basic: {
      label: 'Basic',
      color: CHART_COLORS.plans.basic,
    },
    pro: {
      label: 'Pro',
      color: CHART_COLORS.plans.pro,
    },
    premium: {
      label: 'Premium',
      color: CHART_COLORS.plans.premium,
    },
  };

  return (
    <ChartContainer config={chartConfig} className="h-[300px] w-full">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" className="stroke-muted" />
          <XAxis
            dataKey="date"
            tick={{ fontSize: 12 }}
            tickFormatter={(value) => {
              const date = new Date(value);
              return `${date.getDate()}/${date.getMonth() + 1}`;
            }}
          />
          <YAxis tick={{ fontSize: 12 }} />
          <ChartTooltip content={<ChartTooltipContent />} />
          <Legend />
          <Line
            type="monotone"
            dataKey="free"
            stroke={CHART_COLORS.plans.free}
            strokeWidth={2}
            dot={{ fill: CHART_COLORS.plans.free }}
          />
          <Line
            type="monotone"
            dataKey="basic"
            stroke={CHART_COLORS.plans.basic}
            strokeWidth={2}
            dot={{ fill: CHART_COLORS.plans.basic }}
          />
          <Line
            type="monotone"
            dataKey="pro"
            stroke={CHART_COLORS.plans.pro}
            strokeWidth={2}
            dot={{ fill: CHART_COLORS.plans.pro }}
          />
          <Line
            type="monotone"
            dataKey="premium"
            stroke={CHART_COLORS.plans.premium}
            strokeWidth={2}
            dot={{ fill: CHART_COLORS.plans.premium }}
          />
        </LineChart>
      </ResponsiveContainer>
    </ChartContainer>
  );
};
